import * as React from "react";
const SvgPrograms = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8.733 11.633 11.067 9.3c.122-.123.21-.259.267-.409.055-.15.083-.308.083-.475 0-.355-.125-.658-.375-.908a1.237 1.237 0 0 0-.909-.375c-.222 0-.444.072-.666.217-.222.144-.467.377-.734.7-.266-.323-.51-.556-.733-.7a1.216 1.216 0 0 0-.667-.217c-.355 0-.658.125-.908.375s-.375.553-.375.908c0 .167.028.325.083.475.056.15.145.286.267.409l2.333 2.333Zm.584 2.75c-.2.2-.442.3-.725.3a.988.988 0 0 1-.725-.3l-6.25-6.25a.875.875 0 0 1-.225-.35 1.257 1.257 0 0 1-.058-.383V2.333c0-.289.094-.528.283-.717a.971.971 0 0 1 .716-.283H7.4c.133 0 .267.02.4.058a.856.856 0 0 1 .367.225l6.216 6.217c.212.211.317.458.317.742 0 .283-.105.53-.316.741l-5.067 5.067Zm-.684-.683L13.7 8.633l-6.3-6.3H2.333V7.4l6.3 6.3Zm-4.55-8.767a.832.832 0 0 0 .609-.258.832.832 0 0 0 .258-.609.832.832 0 0 0-.258-.608.832.832 0 0 0-.609-.258.832.832 0 0 0-.608.258.832.832 0 0 0-.258.608c0 .234.086.436.258.609a.832.832 0 0 0 .608.258Z"
    />
  </svg>
);
export default SvgPrograms;
